import type React from 'react';

import type { StatusBannerAutoHideProps } from '@xing-com/banner';

import * as Styled from './statys-banner.styles';

export const StatusBanner: React.FC<StatusBannerAutoHideProps> = ({
  children,
  ...props
}) => {
  return (
    <Styled.StatusBannerFixedContainer>
      <Styled.StatusBanner display="inline" {...props}>
        {children}
      </Styled.StatusBanner>
    </Styled.StatusBannerFixedContainer>
  );
};
